export default __webpack_public_path__ + "static/media/farming.6ef3de26.png";